import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { CalendarProps } from "./types";

export const details = {
  name: "Calendar",
  description: "Calendar widget integrated with Google Calendar",
  tags: ["Organization", "Productivity"],
  category: "Widget",
  grid: {
    extraSmall: [1, 1],
    small: [2, 1],
    medium: [2, 2],
    large: [4, 2],
  },
  gridNames: {
    extraSmall: "Extra Small",
    small: "Small",
    medium: "Medium",
    large: "Large",
  },
  app: lazy(() => import("./App").then(m => ({ default: m.App }))),
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  integrationsUsed: ["google"],
  integrationScopes: { google: ["calendar"] },
  defaultProps: {
    size: "medium",
    style: "calendar",
    dateStyle: "large",
    calendarIds: ["primary"],
  },
} as ElementDetails<CalendarProps>;
